module.exports = __webpack_public_path__ + "img/man_3_3.30229ba9.png";